import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SiteResponse } from '../../models/sites-management/site-response';

@Injectable({
  providedIn: 'root'
})
export class SidebarStateService {
  private readonly SELECTED_SHOP_ID_KEY = 'selectedShopId';
  private readonly SELECTED_SHOP_NAME_KEY = 'selectedShopName';

  private selectedShopIdSubject = new BehaviorSubject<string | null>(this.getInitialShopId());
  public selectedShopId$: Observable<string | null> = this.selectedShopIdSubject.asObservable();

  // Nouveau subject pour notifier les changements de nom de shop
  private shopNameUpdateSubject = new BehaviorSubject<{ shopId: string, newName: string } | null>(null);
  public shopNameUpdate$: Observable<{ shopId: string, newName: string } | null> = this.shopNameUpdateSubject.asObservable();

  // Nouveau subject pour notifier qu'il faut rafraîchir la liste complète
  private refreshListSubject = new Subject<void>();
  public refreshList$: Observable<void> = this.refreshListSubject.asObservable();

  private readonly createShopSubject = new Subject<void>();
  readonly createShop$ = this.createShopSubject.asObservable();
  requestShopCreation(): void { this.createShopSubject.next(); }

  constructor() { }

  private getInitialShopId(): string | null {
    return localStorage.getItem(this.SELECTED_SHOP_ID_KEY);
  }

  private getInitialShopName(): string | null {
    return localStorage.getItem(this.SELECTED_SHOP_NAME_KEY);
  }

  setSelectedShop(shop: SiteResponse | null): void {
    if (shop && shop.id) {
      localStorage.setItem(this.SELECTED_SHOP_ID_KEY, shop.id);
      if (shop.site_name) {
        localStorage.setItem(this.SELECTED_SHOP_NAME_KEY, shop.site_name);
      }
      this.selectedShopIdSubject.next(shop.id);
    } else {
      this.clearSelectedShop();
    }
  }

  clearSelectedShop(): void {
    localStorage.removeItem(this.SELECTED_SHOP_ID_KEY);
    localStorage.removeItem(this.SELECTED_SHOP_NAME_KEY);
    this.selectedShopIdSubject.next(null);
  }

  // Nouvelle méthode pour notifier la mise à jour du nom de shop
  updateShopName(shopId: string, newName: string): void {
    this.shopNameUpdateSubject.next({ shopId, newName });
  }

  // Notifier qu'il faut rafraîchir la liste des sites
  notifyListChanged(): void {
    this.refreshListSubject.next();
  }
}

